import { Button } from '@shopify/polaris';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faGaugeHigh, faPalette, faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';

const supportTips = [
    {
        title: 'Start from templates',
        description: 'Pick a template first, then refine text and timing to match your campaign goals.',
        icon: faWandMagicSparkles,
    },
    {
        title: 'Tune placement by page',
        description: 'Use focused placements so each widget appears exactly where customers make decisions.',
        icon: faGaugeHigh,
    },
    {
        title: 'Keep design consistent',
        description: 'Match brand colors and spacing so urgency widgets feel native to your storefront.',
        icon: faPalette,
    },
];

export function SupportPage() {
    return (
        <div className="mv-support-page">
            <section className="mv-support-hero mv-reveal">
                <h2 className="mv-support-title">Support and Success</h2>
                <p className="mv-support-subtitle">
                    Need help with setup, campaign strategy, or a bug report? Reach out and we will help you get your
                    countdown widgets performing at their best.
                </p>
                <a href="mailto:maxifyapps@gmail.com" className="mv-support-mail">
                    <FontAwesomeIcon icon={faEnvelope} />
                    maxifyapps@gmail.com
                </a>
            </section>

            <section className="mv-support-grid">
                {supportTips.map((tip, index) => (
                    <article
                        className="mv-support-card mv-reveal"
                        style={{ animationDelay: `${120 + index * 70}ms` }}
                        key={tip.title}
                    >
                        <h3>
                            <FontAwesomeIcon icon={tip.icon} /> {tip.title}
                        </h3>
                        <p>{tip.description}</p>
                    </article>
                ))}

                <article className="mv-support-card mv-reveal" style={{ animationDelay: '350ms' }}>
                    <h3>Need direct assistance?</h3>
                    <p>
                        Share your store URL, widget name, and a short issue summary. We can usually reproduce and
                        respond quickly.
                    </p>
                    <div style={{ marginTop: '12px' }}>
                        <Button variant="primary" url="mailto:maxifyapps@gmail.com">
                            Contact support
                        </Button>
                    </div>
                </article>
            </section>
        </div>
    );
}
